import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesWascherComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
          fill="none"
        />
        <path
          d="M12 17.8333C15.2216 17.8333 17.8333 15.2216 17.8333 12C17.8333 8.7783 15.2216 6.16663 12 6.16663C8.7783 6.16663 6.16663 8.7783 6.16663 12C6.16663 15.2216 8.7783 17.8333 12 17.8333Z"
          fill="none"
        />

        <path
          d="M7.83337 12C8.08337 12.2084 8.33337 12.4167 8.87504 12.4167C9.91671 12.4167 9.91671 11.5834 10.9584 11.5834C12.0417 11.5834 11.9584 12.4167 13.0417 12.4167C14.0834 12.4167 14.0834 11.5834 15.125 11.5834C15.6667 11.5834 15.9167 11.7917 16.1667 12"
          fill="none"
        />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesWascherComponent.displayName = 'IconAmenitiesWascher';

const IconAmenitiesWascher = React.memo(IconAmenitiesWascherComponent);

export default IconAmenitiesWascher;
